export function isEmptyFilter(filterData) {
    if (filterData) {
        for (const value of Object.values(filterData)) {
            if (value != null) {
                return false;
            }
        }
    }
    return true;
}
